var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBuildingCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.665039,
    width: 66.67,
    height: 66.67,
    rx: 33.335,
    fill: "#911A1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.165 28.5H41.165V31.5H38.165V28.5ZM41.165 22.5H38.165V25.5H41.165V22.5ZM32.165 37.5H35.165V34.5H32.165V37.5ZM35.165 22.5H32.165V25.5H35.165V22.5ZM32.165 31.5H35.165V28.5H32.165V31.5ZM29.165 22.5H26.165V25.5H29.165V22.5ZM29.165 28.5H26.165V31.5H29.165V28.5ZM37.49 46.5H35.165V41.25H32.165V46.5H23.165V19.5H44.165V31.545C45.23 31.635 46.25 31.965 47.165 32.445V16.5H20.165V49.5H39.53C38.915 48.66 38.165 47.64 37.49 46.5ZM26.165 43.5H29.165V40.5H26.165V43.5ZM29.165 34.5H26.165V37.5H29.165V34.5ZM48.665 39.75C48.665 43.65 43.415 49.5 43.415 49.5C43.415 49.5 38.165 43.65 38.165 39.75C38.165 36.9 40.565 34.5 43.415 34.5C46.265 34.5 48.665 36.9 48.665 39.75ZM45.215 39.9C45.215 39 44.315 38.1 43.415 38.1C42.515 38.1 41.615 38.85 41.615 39.9C41.615 40.8 42.365 41.7 43.415 41.7C44.465 41.7 45.365 40.8 45.215 39.9Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildingCircle);
export default __webpack_public_path__ + "static/media/icon-building-circle.7c99ee5880dc42caad9b0ef8069ff9c8.svg";
export { ForwardRef as ReactComponent };